/* This file should replace dropdowm editor -> select file , so that we can use single dropdown everywhere */

import { withStyles } from "@material-ui/core";
import React from "react";
import Select from '@dataGrid/components/cellEditors/DropdownEditor/Select';
import { ALPHANUMERIC_INPUT_FILTER, isAlphanumericFormat } from '../modules/Dispatch/RouteExecution/constRegex';

const styles = (theme) => ({
  selectControlStyle: {
    "& .select__control": {
      marginTop: 0,
      border: `1px solid ${theme.AnchorBGColor}`,
      borderRadius: 4,
      "&:hover,&.select__control--is-focused": {
        borderRadius: 4,
        border: `1px solid ${theme.AnchorBGColor}`,
      },
    },
  },
  selectMenuStyles: {
    "& .select__menu": {
      borderRadius: 4,
      border: `1px solid ${theme.AnchorBGColor}`,
      maxHeight: 260,
      "& .select__menu-list": {
        maxHeight: 260,
      },
    },  
  },
  dropdownError:{
    "& .select__control": {
      border: `1px solid ${theme.errorBorderColor}`,
      "&:hover,&.select__control--is-focused": {
        border: `1px solid ${theme.errorBorderColor}`,
      },
    }
  },
  errorMessage:{
    color: theme.errorBorderColor,
    padding:"4px 8px",
    fontSize: 12
  }
});

const Dropdown = (props) => {
  const {classes, error, dropdown, dropdownError, errorMessage, ...other} = props;
  const format = props.format || '';
  const maxLength = props.maxLength;
  const baseInputFilter = isAlphanumericFormat(format) ? ALPHANUMERIC_INPUT_FILTER : undefined;
  const inputFilter = props.inputFilter ?? (baseInputFilter
    ? (v) => (maxLength ? baseInputFilter(v).slice(0, maxLength) : baseInputFilter(v))
    : undefined);
  const onChange = (value) => {
    const valueToBeChecked = value?.value ?? null;
    if(props.value !== valueToBeChecked){
        props.onChange(value)
    }
  }

  return (
    <div
      className={`${classes.selectControlStyle} ${classes.selectMenuStyles} ${error ? classes.dropdownError : ""}`}
    >
      <Select
        column={{
          colDef: {
            field: "placeholder",
            cellEditorParams: {
              canAcceptNewValue: props.canAcceptNewValue || false,
              createLabel: props.createLabel || "",
              allOptions: props.allOptions || [], // full unfiltered list; only used when canAcceptNewValue is true to block duplicate creation
              noNullValue: false,
              capitalize: false,
              format: format || "",
              inputFilter,
              maxLength,
              placeholder: "",
              isClearable: props.isClearable || false,
            },
          },
        }}
        selectMenuStyles={styles(other.theme).selectMenuStyles}
        isMultiSelection={props.isMulti || false}
        data={props.options || []} //fallback to empty array if options is undefined
        {...other}
        onChange={onChange}
      />
      {error ? <div className={classes.errorMessage}>{error}</div> : null}
    </div>
  );
};
export default withStyles(styles, { withTheme: true })(Dropdown);
